import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../context/AuthContext";
import { Timer } from "lucide-react";

/** Generic timed quiz runner. questions:[{question,options}], secondsPerQuestion, onSubmit(answers,times) → result */
export default function QuizRunner({ title, questions, secondsPerQuestion, onSubmit, onError }) {
  const limit = secondsPerQuestion * 1000;
  const [idx, setIdx] = useState(0);
  const [left, setLeft] = useState(limit);
  const [answers, setAnswers] = useState([]);
  const [times, setTimes] = useState([]);
  const [busy, setBusy] = useState(false);
  const start = useRef(Date.now());
  useEffect(() => {
    if (busy) return;
    const iv = setInterval(() => { const el = Date.now() - start.current; setLeft(Math.max(0, limit - el)); if (el >= limit) answer(-1); }, 100);
    return () => clearInterval(iv);
  }, [idx, busy]);
  const answer = (i) => {
    const t = Date.now() - start.current, na = [...answers, i], nt = [...times, t];
    setAnswers(na); setTimes(nt);
    if (idx + 1 < questions.length) { setIdx(idx + 1); start.current = Date.now(); setLeft(limit); }
    else { setBusy(true); onSubmit(na, nt).catch(e => { toast.error(e.response?.data?.detail || "Errore"); onError?.(); }); }
  };
  const q = questions[idx];
  return (
    <div className="rl-card p-6 md:p-8 max-w-2xl mx-auto" data-testid="quiz-runner">
      {title && <div className="pill-badge pill-amber mb-3">{title}</div>}
      <div className="flex items-center justify-between mb-4 text-xs font-mono-rl text-slate-400 tracking-widest"><span>DOMANDA {idx + 1}/{questions.length}</span><span className="flex items-center gap-1"><Timer className="w-3 h-3" /> {(left / 1000).toFixed(1)}s</span></div>
      <div className="h-1.5 bg-white/5 rounded-full mb-6 overflow-hidden"><div className="h-full bg-[#FF1E27] transition-[width] duration-100" style={{ width: `${(left / limit) * 100}%` }} /></div>
      <div className="font-display font-bold text-2xl mb-6" data-testid="quiz-question">{q.question}</div>
      <div className="grid gap-3">{q.options.map((o, i) => <button key={i} onClick={() => answer(i)} disabled={busy} data-testid={`quiz-option-${i}`} className="text-left border border-white/10 rounded-lg px-5 py-4 min-h-[56px] hover:border-[#FF1E27] hover:bg-[#FF1E27]/10 transition-colors"><span className="font-mono-rl text-[#FF9F0A] mr-3">{"ABCD"[i]}</span>{o}</button>)}</div>
    </div>
  );
}

export const api = { get: (p) => axios.get(`${API}${p}`), post: (p, b) => axios.post(`${API}${p}`, b) };
